/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import Inputmask from 'inputmask';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

// import * as AppPropTypes from '../../lib/PropTypes';
import TextField from './Text';

import styles from '../../../styles/fields/pincode.module.scss';

Inputmask.extendDefinitions({
    0: { validator: '[0-9０-９]', definitionSymbol: '*' },
    A: { validator: '[A-Za-z0-9]', definitionSymbol: '*' },
    _: { validator: '[A-Za-z0-9]', definitionSymbol: '*' },
});

const propTypes = {
    maxLength: PropTypes.number,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    onChange: PropTypes.func,
    // eslint-disable-next-line react/forbid-prop-types
    inputRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.object })]),
};

const defaultProps = {
    maxLength: null,
    value: null,
    onChange: null,
    placeholder: '000-000-A00',
    className: null,
    inputRef: null,
};

function PincodeField({ maxLength, placeholder, className, inputRef, value, onChange, ...props }) {
    const onFieldChange = useCallback(
        (newValue) => {
            if (onChange !== null) {
                let unmaskedValue = newValue;
                if (newValue !== null) {
                    unmaskedValue =
                        placeholder !== null
                            ? Inputmask.unmask(newValue, { mask: placeholder, placeholder: '' })
                            : newValue.toUpperCase();
                }
                onChange(unmaskedValue);
            }
        },
        [onChange],
    );
    let maskedValue = value;
    if (value !== null && placeholder !== null) {
        maskedValue = Inputmask.format(value, { mask: placeholder, placeholder: '' }).replace(/[^a-zA-Z0-9]+$/g, '');
    }
    return (
        <TextField
            placeholder={placeholder || [...Array(maxLength).keys()].map(() => '0').join('')}
            maxLength={maxLength || placeholder !== null ? placeholder.length : null}
            value={maskedValue}
            className={classNames([styles.container, { [className]: className !== null }])}
            onChange={onFieldChange}
            {...props}
        />
    );
}

PincodeField.propTypes = propTypes;
PincodeField.defaultProps = defaultProps;

export default React.forwardRef((props, ref) => <PincodeField inputRef={ref} {...props} />);
